/** HingeJoint3D parser: the Joint3D surface plus the angular limit keys. */
import { boolSlotValue, writtenScalarSlotValue } from '../../../../godot/variant/variantBool.js';
import { parseJoint3D } from '../joint3d/parser';
export function parseHingeJoint3D(heading, properties) {
    return {
        ...parseJoint3D(heading, properties),
        'angular_limit/enable': boolSlotValue(properties['angular_limit/enable']),
        'angular_limit/lower': writtenScalarSlotValue(properties['angular_limit/lower']),
        'angular_limit/upper': writtenScalarSlotValue(properties['angular_limit/upper']),
    };
}
//# sourceMappingURL=parser.js.map